<div class="toast-container">
  @for (n of notifications; track n) {
    <div
      class="toast"
      [class]="n.type"
      [class.closing]="n.closing"
      (click)="dismiss(n.id)"
    >
      <div class="toast-title" [class]="n.type">
        @switch (n.type) {
          @case ('success') {
            <tech-icon>task_alt</tech-icon>
            <label>SUCCESS</label>
          }
          @case ('error') {
            <tech-icon>error</tech-icon>
            <label>ERROR</label>
          }

          @case ('info') {
            <tech-icon>info</tech-icon>
            <label>INFO</label>
          }
          @case ('warning') {
            <tech-icon>warning</tech-icon>
            <label>WARNING</label>
          }
        }
      </div>
      {{ n.message }}
    </div>
  }
</div>
